import React from "react";
import {
    Input,
    Select,
    Button,
    Space,
    DatePicker,
    Row,
    Col,
    Dropdown,
    Checkbox,
    Modal,
    Tooltip,
    Image,
    Table,
} from "antd";
import Cookies from "js-cookie";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { decode as base64_decode } from "base-64";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import PassengerLogReportStore from "../store/PassengerLogReportStore";
import DeviceGroupsForVehicles from "./DeviceGroupsForVehicles";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import downloadIcon from "../assets/images/NewDesign/Download.svg";
import PDF from "../assets/images/NewDesign/PDF.svg";
import Excel from "../assets/images/NewDesign/Excel.svg";
import DailyTripManifestReportStore from "../store/DailyTripManifestReportStore";
const { RangePicker } = DatePicker;

dayjs.extend(customParseFormat);
const { Option } = Select;
class DailyTripManifestReport extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleStudentTableChange = this.handleStudentTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.dailyTripManifestReportStore = new DailyTripManifestReportStore();
        this.vehicleStore = new VehicleStore(this);

        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            company_name: "",
            listUpdated: 0,
            companyId: "",
            // fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            // toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
            selectedVehicles: [],
            selectAllVehicles: false,

            modalVisible: false,
            column: "",
            filter: "",
            Notcompany: false,
            Notasset: false,
            showMonthPopup: false,
            passengerStatus: null,
            searchStudent: "",
            dateWiseReport: false,
            monthWiseReport: false,
            fromDate: "",
            toDate: "",
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD 23:59:59"),
            Notdate: false,
            reportType: null,
            loadedStudentsData: {},
            pickupFilter: "All",
            studentPageSize: 10,
            studentCurrentPage: 1,
            selectedColumns: [
                // {
                //     title: context.translate("_tripId_"),
                //     dataIndex: "tripId",
                //     key: "tripId",
                //     width: 100,
                //     ellipsis: { showTitle: true },
                // },
                {
                    title: context.translate("_VEHICLE_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                    width: 100,
                    ellipsis: { showTitle: true },
                },
                {
                    title: context.translate("_TRIP_NAME_"),
                    dataIndex: "tripName",
                    key: "tripName",
                    width: 100,
                    ellipsis: { showTitle: true },
                },
                {
                    title: context.translate("_TRIP_TYPE_"),
                    dataIndex: "tripType",
                    key: "tripType",
                    width: 100,
                    ellipsis: { showTitle: true },
                },
                {
                    title: context.translate("_TRIP_START_TIME_"),
                    dataIndex: "startTime",
                    key: "startTime",
                    width: 100,
                    ellipsis: { showTitle: true },
                },
                {
                    title: context.translate("_TRIP_END_TIME_"),
                    dataIndex: "endTime",
                    key: "endTime",
                    width: 100,
                    ellipsis: { showTitle: true },
                },
                {
                    title: context.translate("_TRIP_STATUS_"),
                    dataIndex: "tripStatus",
                    key: "tripStatus",
                    width: 100,
                    ellipsis: { showTitle: true },
                }

            ]

        };
        this.ExportMenuProps = {
            items: [
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={Excel}
                            ></Image>
                            {context.translate("_EXPORT_AS_EXCEL_")}
                        </div>
                    ),
                    key: "excel",
                },
                {
                    label: (
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "5px",
                            }}
                        >
                            {" "}
                            <Image
                                style={{ height: "18px", width: "18px", borderRadius: "0px" }}
                                src={PDF}
                            ></Image>
                            {context.translate("_EXPORT_AS_PDF_")}
                        </div>
                    ),
                    key: "pdf",
                },
            ],
            onClick: (val) => {
                let result = [];

                if (true) {
                    this.state.selectedColumns.map((obj) => result.push(obj.dataIndex));

                    var getData = {
                        companyId: this.state.companyId,
                        vehicleId: this.state.selectedVehicles,
                        intervel: this.state.intervel,
                        fromDate: this.state.fromDate,
                        toDate: this.state.toDate,
                        userId: JSON.parse(base64_decode(Cookies.get("data"))).userId,
                        PickDrop: "All",
                        // userId: 1,
                        filter: this.state.filter,
                        searchStudent: this.state.searchStudent,
                        colList: result.toString(),
                    };
                    if (val.key === "excel") {
                        this.dailyTripManifestReportStore.exportExcel(getData);
                    }
                    if (val.key === "pdf") {
                        this.dailyTripManifestReportStore.exportpdf(getData);
                    }

                }
            },
        };

        this.newColumns = [...this.state.selectedColumns];
    }

    async componentDidMount() {
        this.setState({ pageSize: 50 });
        if (Number(this.props.getUserData().isadmin) !== -1) {
            let companyId = this.props.getUserData().userCompanyId;

            this.setState({ companyId: companyId });
            this.handleChange({ value: companyId });
        }

        await this.setState({ column: this.state.selectedColumns });
    }

    async handleTableChange(pagination, filters, sorter) {
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        this.showData();
    }



    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({ currentPage: 1, companyId: comp?.value });
        await this.setState({ selectedVehicles: [], selectAllVehicles: false });
        await this.vehicleStore.getVehiclesCompanyId(comp?.value);
        //  await this.handleSearch();
        await this.setState({ listUpdated: 1 });
    }

    async handleSearch() {
        this.setState({ loading: true });
        this.setState({ Notasset: false });
        await this.dailyTripManifestReportStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
        });

        await this.setState({ listUpdated: 1 }); //need to reload data
    }
    addMonths = (date, months) => {
        // date.setMonth(date.getMonth() + months);
        // date = date + months;
        var indx = dayjs().month() + -6;
        // return date.format("YYYY-MM-DD HH:mm:ss");
        return dayjs().month(indx);
    };
    checkFromDate(dates) {
        //  var fromDate = dates.format("YYYY-MM-DD HH:mm:ss");
        var fromDate = dates;
        var pdate = this.addMonths();
        if (pdate > fromDate) {
            //  Ext.Msg.show({
            //      title: fleet.Language.get('_FLEET_ALERT_'),
            //      msg: fleet.Language.get('_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_'),
            //      buttons: Ext.Msg.OK,
            //  });
            this.setState({ showMonthPopup: true });
            return false;
        } else {
            return true;
        }
    }


    showData = async () => {
        console.log("showData")
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }
        if (this.state.selectedVehicles.length === 0) {
            this.setState({ Notasset: true });
        } else {
            this.setState({ Notasset: false });
        }
        if (!this.state.fromDate) {
            this.setState({ Notdate: true });
        } else {
            this.setState({ Notdate: false });
        }
        console.log("pndnn")
        if (this.state.companyId && this.state.selectedVehicles.length > 0) {
            console.log("pnkjfsvdnn")
            // this.setState({mandatory:false})
            this.setState({ Notcompany: false, Notasset: false });
            if (this.checkFromDate(this.state.fromdateStdTime)) {
                await this.dailyTripManifestReportStore.loadData({
                    offset: (this.state.currentPage - 1) * this.state.pageSize,
                    limit: this.state.pageSize,
                    companyId: this.state.companyId,
                    vehicleId: this.state.selectedVehicles,
                    fromDate: this.state.fromDate,
                    toDate: this.state.toDate,
                    pageNo: this.state.currentPage,
                });
                this.setState({ loading: false });
            }
        }
    };

    handleSearchStudent = async (val) => {
        await this.dailyTripManifestReportStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            fromDate: this.state.fromDate,
            toDate: this.state.toDate,
            pageNo: this.state.currentPage,
            searchStudent: val,
            reportType: this.state.reportType,
            pickupFilter: this.state.pickupFilter
        });
        this.setState({ loading: false });
    }
    handleAllSelectVehicles = async (e) => {
        if (this.state.selectAllVehicles) {
            const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
                (val) => {
                    return val.vehicleId;
                }
            );
            await this.setState({ selectedVehicles: allVehicles });
        } else {
            await this.setState({ selectedVehicles: [] });
        }
    };

    handleCheckboxChange = async (column) => {
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );

            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
            // await  this.updateVisibleColumns();
        }
    };
    refreshList = async () => {
        await this.setState({ loading: false, pageNo: 1, currentPage: 1 });
        await this.showData();
    };


    onExpand = async (expanded, record) => {
        console.log(record);
        const expandedRowKeys = expanded ? [record.id] : [];
        this.setState({ expandedRowKeys });

        if (expanded) {
            await this.handleExpandRow(record);
        } else {

            this.setState((prevState) => {
                const updated = { ...prevState.loadedStudentsData };
                delete updated[record.id];
                return { loadedStudentsData: updated };
            });
        }
    };

    handleExpandRow = async (record) => {
        console.log(record)
        const dta = {
            tripId: record.tripId,
            startTime: record.startTime,
            endTime: record.endTime,
            vehicleId: record.vehicleId
        }
        // debugger
        const data = await this.dailyTripManifestReportStore.loadStudentsData(dta);
        // console.log(data)

        this.setState((prevState) => ({
            studentsDataMap: {
                ...prevState.studentsDataMap,
                [record.tripId]: data,
            },
        }));
        console.log("fadssadads", this.state.studentsDataMap)
    };

    async handleStudentTableChange(pagination, filters, sorter) {
        const { expandedRowKeys } = this.state;
        const tripId = expandedRowKeys[0];

        const record = this.props.dataSource.find(
            (item) => item.tripId === tripId
        );
        await this.setState({
            studentCurrentPage: pagination.current,
            studentPageSize: pagination.pageSize,
        });
        await this.handleChangeStudentTable(record);
    }

    handleChangeStudentTable = async (record) => {
        const data = record || this.state.expandedRowData;
        console.log(this.state.expandedRowData, "this.state.expandedRowData")
        await this.dailyTripManifestReportStore.loadStudentsData({
            tripId: data.tripId,
            fromDate: data.fromDate,
            toDate: data.toDate,
            offset: (this.state.studentCurrentPage - 1) * this.state.studentPageSize,
            limit: this.state.studentPageSize
        });
        this.setState({ loadData: 1 })
    }

    getExpandedColumns = () => {
        const allColumns = [
            {
                // title: "Vehicle No",
                title: this.context.translate("_FLEET_DASHBORD_RULETRIGGER_VEHICLE_"),
                dataIndex: "vehicleNo",
                key: "vehicleNo",
                width: 100,
                ellipsis: { showTitle: true },
                render: (vehicleNo) => (
                    <Tooltip placement="topLeft" title={vehicleNo}>
                        {vehicleNo}
                    </Tooltip>
                ),
            },
            {
                // title: "Passenger TagId",
                title: this.context.translate("Trip Type"),
                dataIndex: "tripType",
                key: "tripType",
                width: 100,
                ellipsis: { showTitle: true },
            },


            {
                // title: "Passenger Name",
                title: this.context.translate("_STUDENT_NAME_"),
                dataIndex: "studentName",
                key: "studentName",
                width: 100,
                ellipsis: { showTitle: true },
            },
            {
                // title: "Login Location",
                title: this.context.translate("_LOGIN_LOCATION_"),
                dataIndex: "spInLocation",
                key: "loginLocation",
                width: 100,
                ellipsis: { showTitle: true },
            },
            {
                // title: "Log Out Location",
                title: this.context.translate("_LOGOUT_LOCATION_"),
                dataIndex: "spOutLocation",
                key: "logoutlocation",
                width: 100,
                ellipsis: { showTitle: true },
            },
            {
                // title: "Login Time",
                title: this.context.translate("_LOGIN_TIME_"),
                dataIndex: "spInTime",
                key: "logintime",
                width: 100,
                ellipsis: { showTitle: true },
                render: (value) => {
                    if (value) {
                        const formattedDateTime = dayjs(value).format(
                            "DD-MM-YYYY hh:mm:ss A"
                        );
                        return <>{formattedDateTime}</>;
                    }
                },
            },
            {
                // title: "Logout Time",
                title: this.context.translate("_LOGOUT_TIME_"),
                dataIndex: "spOutTime",
                key: "logouttime",
                width: 100,
                ellipsis: { showTitle: true },

                render: (value) => {
                    if (value) {
                        const formattedDateTime = dayjs(value).format(
                            "DD-MM-YYYY hh:mm:ss A"
                        );
                        return <>{formattedDateTime}</>;
                    }
                },
            },
            {
                // title: "Status",
                title: this.context.translate("_FLEET_DASHBORD_DROWGEO_ALERTSTATUS_"),
                dataIndex: "inOutStatus",
                key: "status",
                width: 100,
                ellipsis: { showTitle: true },
            },
        ]

        return allColumns

    };

    expandedRowRender = (record) => {

        console.log(this.dailyTripManifestReportStore.studentsData, "record")

        const columns = this.getExpandedColumns();
        return (
            <div className="innerGridTbl">
                <Table
                    bordered
                    size="small"
                    style={{ padding: "20px 20px 20px 10px" }}
                    columns={columns}
                    dataSource={this.dailyTripManifestReportStore.studentsData || []}
                    pagination={false}
                    loading={this.dailyTripManifestReportStore?.loading}

                />
            </div>
        );
    };
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromdateStdTime: dates[0],
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        } else {
            this.setState({ fromDate: "", toDate: "" });
        }
    };

    render() {
        return (
            <>
                <div className="listHeader">
                    <Row className="listInputRow">
                        <Col span={20}>
                            <Space>
                                <CompanyAutocomplete
                                    className="searchInput"
                                    onChange={(value) => this.handleChange(value)}
                                    allowClear={true}
                                    style={{ width: 150 }}
                                    // style={companyInputStyle}
                                    status={this.state.Notcompany ? "error" : false}
                                />

                                {this.props.getUserData().isadmin === 1 && (
                                    <DeviceGroupsForVehicles
                                        vehicleStore={this.vehicleStore}
                                        setLoadDta={() => this.setState({ loadData: 1 })}
                                        resetVehicles={() =>
                                            this.setState({
                                                selectedVehicles: [],
                                                selectAllVehicles: false,
                                            })
                                        }
                                    />
                                )}

                                <Checkbox
                                    checked={this.state.selectAllVehicles}
                                    onChange={async (e) => {
                                        await this.setState({
                                            selectAllVehicles: e.target.checked,
                                        });

                                        await this.handleAllSelectVehicles();
                                    }}
                                />
                                {/* All */}
                                {this.context.translate("_ALL_")}
                                {"  "}

                                <Select
                                    maxTagCount="responsive"
                                    className="searchInput"
                                    value={this.state.selectedVehicles}
                                    onChange={(val) => {
                                        this.setState({ selectedVehicles: val });
                                        if (
                                            this.vehicleStore?.getVehiclesUsingCompanyId?.length >
                                            val.length
                                        ) {
                                            this.setState({ selectAllVehicles: false });
                                        } else {
                                            this.setState({ selectAllVehicles: true });
                                        }

                                        if (val?.length > 1) {
                                            this.setState({ showAlertPopup: true });
                                        }
                                    }}
                                    style={{ width: 150 }}
                                    showSearch
                                    status={this.state.Notasset ? "error" : false}
                                    mode="multiple"
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                                    )}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                                        return (
                                            <Option key={val.vehicleId} value={val.vehicleId}>{val.vehicleNo}</Option>
                                        );
                                    })}
                                </Select>

                                <RangePicker
                                    placeholder={[
                                        this.context.translate("_FROM_DATE_TIME_"),
                                        this.context.translate("_TO_DATETIME_"),
                                    ]}
                                    format="DD-MM-YYYY hh:mmA"
                                    style={{ width: 400, borderRadius: "25px" }}
                                    onChange={(val) => {
                                        this.onDateTimeChange(val);
                                    }}
                                    // disabledDate={(current) => {
                                    //   return current && current > dayjs();
                                    // }}
                                    showTime={{
                                        format: "h:mmA",
                                        defaultValue: [
                                            dayjs().startOf("day"),
                                            dayjs().endOf("day"),
                                        ],
                                    }}
                                    status={this.state.Notdate ? "error" : false}
                                    defaultValue={[dayjs().startOf("day"), dayjs().endOf("day")]}
                                />

                                {/* <Input style={{ width: 190, borderRadius: 25 }}
                                    placeholder="Search By Student Name"
                                    onChange={(e) => { this.setState({ searchStudent: e.target.value }); this.handleSearchStudent(e.target.value) }}
                                     /> */}

                                <Button type="primary" onClick={() => this.showData()}>
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                            </Space>
                        </Col>
                        <Col
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                            span={4}
                        >
                            <Space>
                                <Tooltip
                                    title={this.context.translate("_REFRESH_")}
                                    placement="bottom"
                                >
                                    <Image
                                        style={{
                                            height: 18,
                                            marginInlineEnd: "20px",
                                            alignItems: "center",
                                            cursor: "pointer",
                                        }}
                                        src={refreshIcon}
                                        onClick={() => this.refreshList()}
                                    ></Image>
                                </Tooltip>
                                {/* <Button
                                    className="downloadExcelButton"
                                    disabled={
                                        this.dailyTripManifestReportStore?.passengers?.length > 0
                                            ? false
                                            : true
                                    }
                                >
                                    <Dropdown
                                        overlayClassName="export-dropdown"
                                        menu={this.ExportMenuProps}
                                    >
                                        <Image
                                            style={{
                                                height: 18,
                                                alignItems: "center",
                                                marginInlineEnd: "30px",
                                            }}
                                            src={downloadIcon}
                                        ></Image>
                                    </Dropdown>
                                </Button> */}
                            </Space>
                        </Col>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        // rowKey="tripId"
                        rowKey="id"
                        expandable={{
                            expandedRowRender: this.expandedRowRender,
                            onExpand: this.onExpand,
                            expandedRowKeys: this.state.expandedRowKeys,
                        }}
                        key={this.state.selectedColumns.length}
                        current={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.dailyTripManifestReportStore?.total}
                        columns={this.state.selectedColumns}
                        dataSource={this.dailyTripManifestReportStore?.tripdetails}
                        loading={this.dailyTripManifestReportStore?.loading}
                        onChange={this.handleTableChange}
                        scroll={{
                            x: 100,
                        }}
                    />

                    <Modal
                        width={350}
                        className="alert-model"
                        title={
                            <div>
                                {" "}
                                <i
                                    style={{ color: "red", fontSize: "18px", marginRight: "5px" }}
                                    class="bi bi-exclamation-triangle"
                                ></i>{" "}
                                {this.context.translate("_FLEET_ALERT_")}
                            </div>
                        }
                        open={this.state.showMonthPopup}
                        onOk={() => this.setState({ showMonthPopup: false })}
                        onCancel={() => this.setState({ showMonthPopup: false })}
                        footer={false}
                    >
                        {/* For reports prior to 6 months please contact administrator */}
                        {this.context.translate("_REPORTS_PRIOR_CONTACT_ADMINISTRATOR_")}
                    </Modal>
                </div>
            </>
        );
    }
}
DailyTripManifestReport.contextType = StoreContext;
export default observer(withRouter(DailyTripManifestReport));
